import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { useTranslation } from 'react-i18next';
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  arrayUnion
} from 'firebase/firestore';
import './CustomerTombola.css';

const CustomerTombola = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [customer, setCustomer] = useState(null);
  const [tombolas, setTombolas] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const lang = localStorage.getItem('i18nextLng') || 'en';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const custSnap = await getDocs(query(
          collection(db, 'customers'),
          where('token', '==', token)
        ));

        if (!custSnap.empty) {
          const custData = custSnap.docs[0].data();
          setCustomer({ id: custSnap.docs[0].id, ...custData });

          const tombolasSnap = await getDocs(query(
            collection(db, 'tombolas'),
            where('coffee_shop_id', '==', custData.coffee_shop_id)
          ));
          const tombolasArray = tombolasSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setTombolas(tombolasArray);
        } else {
          setMessage(t('customer_not_found'));
        }
      } catch (error) {
        console.error("Fetching data failed:", error);
        setMessage(t('load_error'));
      }
    };
    fetchData();
  }, [token, t]);

  const participateInTombola = async (tombolaId, minPointsRequired) => {
    try {
      const totalPoints = customer.total_points || 0;

      if (totalPoints < minPointsRequired) {
        alert(t('not_enough_points', {
          required: minPointsRequired,
          current: totalPoints
        }));
        return;
      }

      await updateDoc(doc(db, 'tombolas', tombolaId), {
        participants: arrayUnion({ token: customer.token, name: customer.name })
      });

      alert(t('participation_success'));
    } catch (error) {
      console.error("Participation error:", error);
      alert(t('participation_error'));
    }
  };

  if (!customer && !message) return <div className="loading">{t('loading')}</div>;

  return (
    <div className="customer-tombola-container">
      <header>
        <h2>🎟️ {t('tombola_participation')}</h2>
      </header>

      {message && <div className="notification">{message}</div>}

      {tombolas.length > 0 ? (
        tombolas.map(tb => (
          <div key={tb.id} className="tombola-card">
            <h4>{tb.year} {t('tombola')}</h4>
            <ul>
              {tb.awards.map((award, idx) => (
                <li key={idx}>
                  {award.description}
                  {award.image_url && (
                    <img
                      src={award.image_url}
                      alt={award.description}
                      className="customer-tombola-image"
                    />
                  )}
                </li>
              ))}
            </ul>
            <button
              className="participate-btn"
              onClick={() => participateInTombola(tb.id, tb.min_points_required)}
            >
              🎟️ {t('participate')}
            </button>

            {tb.winners && tb.winners.length > 0 && (
              <div className="tombola-winners">
                <h4>🏆 {t('winners')}</h4>
                <ul>
                  {tb.winners.map((winner, idx) => (
                    <li key={idx}>{winner.name || winner.token}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))
      ) : (
        <p>{t('no_active_tombolas')}</p>
      )}

      <button className="back-dashboard" onClick={() => navigate(-1)}>
        ⬅️ {t('go_back')}
      </button>
    </div>
  );
};

export default CustomerTombola;